import { render } from "./PesosSku.vue?vue&type=template&id=2985c66b"
import script from "./PesosSku.vue?vue&type=script&lang=js"
export * from "./PesosSku.vue?vue&type=script&lang=js"

import "./PesosSku.vue?vue&type=style&index=0&id=2985c66b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__